export default {
  namespaced: true,
  state: { instance: null },
  getters: {
    GET_WS(state) {
      return state.instance
    },
  },
  mutations: {
    SET(state, instance) {
      state.instance = instance
    }
  },
  actions: {
    set({commit}, instance) {
      commit('SET', instance)
    },
  },
}
